const IntercomConstants = {
  INTERCOM_API_ID: process.env.REACT_APP_INTERCOM_API_KEY,
  INTERCOM_SCRIPT_URL: `https://widget.intercom.io/widget/${process.env.REACT_APP_INTERCOM_API_KEY}`,
  INTERCOM_API_BASE_URL: 'https://api-iam.intercom.io',
};

export default IntercomConstants;
